<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ resource.name }}</h3>
      <nav-secondary-vehicle :vehicle="vehicle" />
    </route-header>
    <div class="row mb-3">
      <div class="col">
        <vehicle-events :vehicle="vehicle" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <tracking :vehicle="vehicle" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VehicleTracking',
  props: ['vehicle'],
  computed: {
    ...mapState({
      auth: state => state.auth,
      resource: state => state.vehicle.data
    })
  }
}
</script>
